import * as React from "react";
import { Logger } from "./logger.js";
export * from "./system-event.js";
export * from "./logger.js";
const defaults = new Logger({});
const Context = React.createContext(defaults);
export const LoggerProvider = (props) => {
  const { logger, children } = props;
  const value = logger ? new Logger(logger) : defaults;
  return /* @__PURE__ */ React.createElement(Context.Provider, { value }, children || null);
};
LoggerProvider.displayName = "LoggerProvider";
export const useLogger = () => {
  return React.useContext(Context);
};
